// Fades in every [data-reveal] element on the page the first time it scrolls into view.
// Add data-reveal="2" to delay an element by 2 × 80 ms (for staggered cards).
export default {
  mounted() {
    this.$nextTick(() => {
      const items = this.$el.querySelectorAll("[data-reveal]");
      items.forEach((el) => {
        const step = Number(el.getAttribute("data-reveal")) || 0;
        if (step) el.style.transitionDelay = `${step * 80}ms`;
      });
      if (!("IntersectionObserver" in window)) {
        items.forEach((el) => el.classList.add("is-in"));
        return;
      }
      this._revealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add("is-in");
            this._revealObserver.unobserve(entry.target);
          });
        },
        { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
      );
      items.forEach((el) => this._revealObserver.observe(el));
    });
  },
  beforeDestroy() {
    if (this._revealObserver) this._revealObserver.disconnect();
  },
};